import React, { createContext, useReducer} from 'react'
import reducer from './reducers/reducer'
import { courseReportState } from './initialStates/courseReportState'

const CourseReportContext = createContext();

export function CourseReportContextProvider({children}) {
    const [reportState, reportDispatch] = useReducer( reducer, courseReportState)
    return (
        <CourseReportContext.Provider value={[reportState,reportDispatch]}>
            {children}
        </CourseReportContext.Provider>
    )
}

export default CourseReportContext